import type { PeopleFinderPerson } from "@hooks/peopleFinder/usePeopleFinder";

export function escapeVCardValue(value: string): string {
  return value
    .replace(/\\/g, String.raw`\\`)
    .replace(/\r\n|\r|\n/g, String.raw`\n`)
    .replace(/;/g, String.raw`\;`)
    .replace(/,/g, String.raw`\,`);
}

export function generateVCard(person: PeopleFinderPerson): string {
  const firstName = escapeVCardValue(person.firstName);
  const lastName = escapeVCardValue(person.lastName);
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${firstName} ${lastName}`,
    `N:${lastName};${firstName};;;`,
  ];

  if (person.ponMobilePhone) {
    lines.push(`TEL:${escapeVCardValue(person.ponMobilePhone)}`);
  }

  if (person.opcoEmailAccount) {
    lines.push(`EMAIL:${escapeVCardValue(person.opcoEmailAccount)}`);
  }

  lines.push("END:VCARD");

  return lines.join("\r\n");
}
